export const WHATSAPP_SUPPORT_URL =
  "https://api.whatsapp.com/send/?phone=27600180090&text=Hi%2080eight%2C&type=phone_number&app_absent=0";
